import { Suspense } from 'react'
import { useLocation } from 'react-router'
import { WebflowBinder } from '@/components/chrome/WebflowBinder'

/**
 * Suspense boundary for the document templates, with the Webflow binder.
 *
 * The binder has to mount *after* the markup it scans, which is why it sits
 * inside the boundary rather than beside it — a sibling of a suspended tree
 * runs its effects before that tree commits, and the engine would scan an
 * empty document.
 *
 * These four routes carry no Webflow interaction markup of their own; they are
 * built from `Section`, `Prose` and the section components. The engine is
 * still needed for the shared chrome's nav dropdowns, and for the header's
 * contrast pass. It goes when Phase 6 does.
 */
export function DocumentRoute({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation()
  return (
    <Suspense fallback={<div className="min-h-screen" />}>
      {children}
      <WebflowBinder key={`bind:${pathname}`} route={pathname} />
    </Suspense>
  )
}
